import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { TranslateService } from "@ngx-translate/core";
import { ScratchPadOrder } from "./ScratchPadOrder";
import { OrderStateSCHelper } from "./OrderStateSCHelper";
import { COLUMN_ORDER_STATE } from "../OrdersTableDefinitionFactory.constants";
import { ISystemConfigService } from "shared/cubiq-services/profile/ISystemConfigService";
import { PricingService } from "shared/cubiq-services/lookup/pricing/PricingService";
import { ITraderGroupLookupService } from "shared/cubiq-services/lookup/model/ITraderGroupLookupService";
import { IUserLookupService } from "shared/cubiq-services/lookup/model/IUserLookupService";
import { StatusIconsHelper } from "./StatusIconsHelper";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

export const DONT_INCL_DESC = false;

export class StatusIconSCHelper {
  private orderStateHelper: OrderStateSCHelper;
  private myStatusIconHelper: StatusIconsHelper;

  constructor(
    protected userLookupService: IUserLookupService,
    protected sysConfig: ISystemConfigService,
    protected translate: TranslateService,
    protected pricingService: PricingService,
    private traderGroupLookup: ITraderGroupLookupService,
  ) {
    this.orderStateHelper = new OrderStateSCHelper(COLUMN_ORDER_STATE, translate);

    this.myStatusIconHelper = new StatusIconsHelper(
      this.userLookupService,
      this.sysConfig,
      this.translate,
      this.pricingService,
      null, // No TSL support
      this.traderGroupLookup,
    );
  }

  getIcons(order: any): string {
    let iconStr: string = "";
    iconStr += this.getCol1Icon(order);
    iconStr += this.getCol2Icon(order);
    return iconStr;
  }

  private getCol1Icon(order: any): string {
    let colStr: string = this.getOrderStateIcon(order);
    if (colStr == "") {
      return '<i class="icon icon-spacer"></i>';
    }
    return colStr;
  }

  private getOrderStateIcon(order: any): string {
    let error: any = this.getErrorMessage(order);

    if (order.orderState === CubiqTS.OrderState.ACCEPTANCE_NEEDED) {
      return '<i class="badge-icon bfx-badge-neutral-bold"' + error + ">N</i>";
    } else if (order.orderState === CubiqTS.OrderState.DI_NEEDED) {
      return '<i class="badge-icon bfx-badge-negative-moderate"' + error + ">DI</i>";
    } else if (order.orderState === CubiqTS.OrderState.REJECTED) {
      return '<i class="icon icon_ion_error_filled bfx-scratchpad-rejected"' + error + "></i>";
    }
    return "";
  }
  // strategy icon
  private getCol2Icon(order: any): string {
    let colStr: string = this.myStatusIconHelper.getStrategyIcon(order, DONT_INCL_DESC);
    if (colStr == "") {
      return '<i class="icon icon-spacer"></i>';
    }
    return colStr;
  }

  private getErrorMessage(order: any): string {
    if (order.errors) {
      try {
        let errors: Array<any> = Array.isArray(order.errors)
          ? order.errors
          : JSON.parse(order.errors);

        if (
          errors.length == 0 &&
          (order as ScratchPadOrder).orderState + "" == CubiqTS.OrderState.ACCEPTANCE_NEEDED + ""
        ) {
          return ' title="' + this.orderStateHelper.getState({ data: order }) + '" ';
        }

        if (errors != null && !Array.isArray(errors)) {
          let error: any = errors;
          if (error.id != null && Array.isArray(error.args)) {
            return ' title="' + this.translateError(error) + '" ';
          }
        }

        return ' title="' + errors.map((err) => this.translateError(err)).join("\n") + '" ';
      } catch (e) {
        logger.out.warn(
          this.constructor.name +
            ": Failed to read errors for scratchpad icon data: " +
            (order != null ? order.errors : "null"),
        );
      }
    }
    return "";
  }

  private translateError(error: any): string {
    try {
      let err: any = error.id != null && Array.isArray(error.args) ? error : JSON.parse(error);
      return this.translate.instant(err.id, err.args);
    } catch (e) {
      logger.out.warn("Failed to translate error: " + error, e);
    }
  }
}
